<template>
  <div class="cashback-popup-detail">
    <div class="cashback-popup-detail__content">
      <div class="cashback-popup-detail__subtitle">
        Your cashback balance
      </div>

      <div class="cashback-popup-detail__available">
        <div class="cashback-popup-detail__available-sum">
          {{ currencyString(data.availableCashback) }}
        </div>

        <div class="cashback-popup-detail__available-desc">
          cover up to {{ coveragePercent }}% of your order with cashback
        </div>
      </div>
    </div>

    <div class="cashback-popup-detail__content">
      <div class="cashback-popup-detail__subtitle">
        Amount to use
      </div>

      <ui-input
        v-model="cashbackSum"
        :placeholder="`${currencyString(5)}`"
        :error="error"
        :z-index-tooltip="2147483011"
        is-currency
        class="cashback-popup-detail__input" />
    </div>

    <button
      class="button button-main cashback-popup-detail__button"
      @click="saveCashbackValue">
      {{ `Reduce the price by ${currencyString(cashbackSum || 0)}` }}
    </button>
  </div>
</template>

<script>
import { formatCurrencyString } from 'Root/helpers/tools';
import UiInput from 'Components/ui/Input/UiInput.vue';

export default {
  name: 'CashbackPopup',

  components: {
    UiInput,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      cashbackSum: this.data.cashbackSum || this.data.maxCashbackValue,
      error: null,
    };
  },

  computed: {
    coveragePercent() {
      const isGoldOrAccount = ['gold', 'account'].includes(this.data.type);
      return isGoldOrAccount ? '6' : '30';
    },
  },

  watch: {
    cashbackSum: {
      handler(newValue) {
        this.error = null;
        if (parseFloat(newValue, 10) > this.data.maxCashbackValue) {
          // eslint-disable-next-line max-len
          this.error = `Cashback amount cannot be more than ${this.currencyString(this.data.maxCashbackValue)}`;
        }
      },
    },
  },

  methods: {
    saveCashbackValue() {
      if (this.error) {
        return;
      }

      this.$vuedals.close({ cashbackSum: this.cashbackSum });
    },

    currencyString(value) {
      return formatCurrencyString(value, this.data.activeRegion.id);
    },
  },
};
</script>

<style lang="scss">
  .mobile-panel-popup.cashback-popup {
    background-color: $color--basic-black;
  }

  @media screen and (min-width: 601px) {
    .mobile-panel-popup.cashback-popup {
      max-width: 550px;
      margin: auto;

      .mobile-panel-popup__body {
        padding: 48px;
        padding-top: 0;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .cashback-popup-detail {
    display: grid;
    grid-gap: 24px;
    font-weight: 500;
  }

  .cashback-popup-detail__subtitle {
    font-size: 15px;
    margin-bottom: 8px;
  }

  .cashback-popup-detail__available {
    display: flex;
    align-items: center;
  }

  .cashback-popup-detail__available-sum {
    font-size: 13px;
    padding: 1em;
    background-color: $color--basic-blue;
    border-radius: 5px;
    margin-right: 16px;
  }

  .cashback-popup-detail__available-desc {
    font-size: 13px;
    color: $color--basic-dark-gray;
  }

  .cashback-popup-detail__button {
    font-size: 13px;
    padding: 1em;
  }

  .cashback-popup-detail__input {
    --height: 40px !important;
    --font-size: 13px !important;
    --padding: 11px 12px !important;
    --color: #{$color--basic-light-gray} !important;
    --background-color: #{$color--basic-dark-gray} !important;

    font-weight: 500;
  }

  @media screen and (min-width: 601px) {
    .cashback-popup-detail {
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 40px;
    }

    .cashback-popup-detail__available-sum {
      font-size: 15px;
    }

    .cashback-popup-detail__input {
      --height: 48px !important;
      --font-size: 15px !important;
      --padding: 15px !important;
    }

    .cashback-popup-detail__button {
      grid-column: 1 / -1;
      font-size: 15px;
    }
  }
</style>
